module.exports = __webpack_public_path__ + "static/partial02-366246f0031ae6178f57f1677817602a.jpg";